import moment from 'moment';

export default {
  // NOTE: name is singular
  name: 'templateLifeEventCategory',
  subtitle: 'Categories are a collection of similar Encouragement Guides',
  isTemplate: true,
  uniqKey: '_id',
  crudMapping: {
    readMany: 'editorLifeEventCategories',
    readOne: 'lifeEventCategory',
    useTemplate: 'createCategoryFromTemplate',
  },
  readOneSchema: {
    show: true,
  },
  readManySchema: {
    cellFormatter(value, object, fieldName) {
      if (fieldName === '_id') {
        return value
          ? moment(new Date(parseInt(value.substring(0, 8), 16) * 1000)).format(
            'MM/DD/YYYY',
          )
          : '';
      }
      return value;
    },
    jsonSchema: {
      type: 'object',
      properties: {
        title: {
          type: 'string',
        },
        sortIndex: {
          type: 'number',
        },
        _id: {
          title: 'Created At',
          type: 'string',
        },
      },
    },
  },
  defaultSchema: {
    jsonSchema: {
      title: ' ',
      type: 'object',
      required: ['title', 'lifeEventThemeIds'],
      properties: {
        title: {
          type: 'string',
        },
        sortIndex: {
          type: 'number',
          default: 1000,
        },
        published: {
          type: 'boolean',
          title: 'Published',
          default: true,
        },
      },
    },
    uiSchema: {
      published: {
        'ui:widget': 'hidden',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/schemas/curator/templateLifeEventCategory.js